import React, { Fragment } from "react";

import config from "../../../config";
import Filter from "../../filter/components/Filter";
import IconclassFilter from "../../iconclass/components/IconclassFilter";

const FacetBox = ({
  triggerUpdate,
  section,
  search,
  header,
  onChangeICLanguage,
  ...props
}) => (
  <Fragment>
    {config.ICONCLASS_ENABLED && (
      <IconclassFilter
        triggerUpdate={triggerUpdate}
        section={section}
        search={search}
        onChangeICLanguage={onChangeICLanguage}
      />
    )}
    <Filter
      header={"Type"}
      triggerUpdate={triggerUpdate}
      section={section}
      search={search}
      facetType="TIPE"
    />
    {section && !section.startsWith("him_") && (
      <Filter
        header={"Collection"}
        triggerUpdate={triggerUpdate}
        section={section}
        search={search}
        facetType="HIM"
      />
    )}
  </Fragment>
);

export default FacetBox;
